const businessStyles = {
    container: {
      display: 'flex',
      height: '93vh',
      alignItems: 'center',
      justifyContent: 'center',
      background: `linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url(https://static.vecteezy.com/system/resources/previews/027/660/549/original/light-blue-cityscape-background-city-buildings-with-bridge-and-ferris-wheel-modern-architectural-panorama-in-flat-style-illustration-horizontal-wallpaper-vector.jpg)`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
    },
  };
  
  export default businessStyles;
  